<div class="default-dialog">
  <div class="dialog-header">
    <div class="title"></div>
    <div class="action">
      <button mat-icon-button (click)="close()" *ngIf="!data.timeout">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <div class="dialog-body">
    <div class="icon-container">
      <ng-container *ngIf="data.icon">
        <mat-icon>{{ data.icon }}</mat-icon>
      </ng-container>
      <ng-container *ngIf="!data.icon">
        <mat-icon>{{ data.mode === 'error' ? 'cancel' : 'check_circle' }}</mat-icon>
      </ng-container>
    </div>

    <ng-container *ngFor="let item of titleText">
      <p>{{ item }}</p>
    </ng-container>
  </div>
  <div class="dialog-footer">
    <button mat-raised-button color="accent" (click)="submit()" *ngIf="!data.timeout">ตกลง</button>
  </div>
</div>
